import { useGetUser } from '@src/api/useUser';
import { useUniSelectorContext } from '@src/contexts/uni-selector/useUniSelectorContext';
import { useEmbeddedAuth } from '@src/contexts/embedded-auth/useEmbeddedAuth';
import { useGetUniversity } from '@src/api/useUniversities';
export function useUniversityPublicWebsiteUrl() {
  const { isAuthenticated } = useEmbeddedAuth();
  const { data: user } = useGetUser(isAuthenticated);
  const { selectedUniversityId } = useUniSelectorContext();
  const { data: selectedUniversity } = useGetUniversity(
    selectedUniversityId ?? ''
  );
  const publicSearchUrl = import.meta.env?.VITE_PUB_URL;
  const userUniversityPath = user?.university?.slug ? user.university.slug : '';
  const superAdminUniversityPath = selectedUniversityId
    ? selectedUniversity?.slug
    : '';
  const universityPath = superAdminUniversityPath || userUniversityPath;

  if (universityPath === '') {
    return { publicWebsiteUrl: publicSearchUrl };
  }
  return { publicWebsiteUrl: `${publicSearchUrl}/${universityPath}` };
}
